import Cookies from 'js-cookie';

window.addEventListener('pageshow', function(e){
  if (e.persisted) {
    window.location.reload();
  }
});

var $window = $(window).scrollTop(0);
var $body = $("body");
var $top = $("#top");
var $list = $("#list");
var $footer = $(".footer");

var _hash = window.location.hash;

window.isDebug = false; //デバッグ
var isEndVote = false; //投票終了
var __name__ = "m7gksC3U";
window.currentPhase = 'phase3';

global._vars = {
  "key": "",
  "path": "",
};

var facilities = {
  "東急プラザ渋谷": "tp_shibuya",
  "オモカド": "omokado",
  "ハラカド": "harakado",
  "東急プラザ銀座": "tp_ginza",
  "東急プラザ蒲田": "tp_kamata",
  "東急プラザ戸塚": "tp_totsuka",
  "ノースポート・モール": "npm",
  "あべのキューズモール": "abeno",
  "あまがさきキューズモール": "amagasaki",
  "みのおキューズモール": "minoo",
  "もりのみやキューズモールBASE": "morinomiya",
  "COCONO SUSUKINO": "coconosusukino",
}

/*
* 施設・お店のPR
* 商品・サービス・キャンペーンPR
* お客さまのココロをつかむ私だけのオリジナルトーク
* */

var themes = {
  "テーマ1": "施設・お店のPR",
  "テーマ2": "商品・サービス・キャンペーンPR",
  "テーマ3": "お客さまのココロをつかむ私だけのオリジナルトーク"
}
var themesReverse = {
  "施設・お店のPR": "テーマ1",
  "商品・サービス・キャンペーンPR": "テーマ2",
  "お客さまのココロをつかむ私だけのオリジナルトーク": "テーマ3"
}

var __c__ = function(a){
  if(isDebug){
    console.log(a);
  }
};

var _apifile = "assets/api/sjxqE6XVhEQR.php";

// デバッグ用
if(isDebug){
  _apifile = "assets/api/test.php";
  __c__("test now");
  __c__(_apifile);
  if(_hash === "#clear"){
    Cookies.remove(__name__, { path: "" });
    __c__("Cookie Removed");
    //window.location.href = ""
  }
}else{
  console.log(window.currentPhase);
}

var originalData = [];
global.allData = [];
var isFilter = false;
var filteredData = [];
var readPage = 1;
var currentCount = 0;
var outputCount = 0;

var _cookiePrefix = "m"; // p (permanent) と c (campaign) 時の Cookies設定で使用するPrefix設定
var __o__ = {
  // n: {"eRmBZ11P": "9DnFNVgn9gtn"}, // normal(2022)
  // p: {"CIQswuqk": "GRAKw5ff4vGM"}, // permanent
  // c: {"HjLxGeSC": "ZV2TLj70cNcF"}, // campaign
  m: {"W7gZCPfu": "i7UJannJY9dW"}, // movie(2024)
}

// 初期
var InitialDataLoad = function(){
  $.ajax({
    url: _apifile,
    type: 'POST',
    data: __o__[_cookiePrefix],
  }).done(function(data){
    var _arr = data.split(";");
    global._vars = {
      "key": _arr[0], "path": _arr[1],
    };
    if(isDebug){
      __c__(_vars);
      $("#debug").append("<div>API PATH: " + _vars["path"] + "</div>");
    }
  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    if(textStatus === "timeout"){
      alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
    }else{
      console.dir(XMLHttpRequest);
      console.log(textStatus);
      console.log(errorThrown);
      if(errorThrown !== 'abort'){
        alert('データ受信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + errorThrown + ' >>');
      }
    }
  });
};
InitialDataLoad();

// CookieにID値を入れ込む
var SetCookieValue = function(id){
  if(Cookies.get(__name__) === undefined){
    Cookies.set(__name__, id, { expires : 60, path: "" });
  }else{
    if(CheckCookieValue(id) === false){
      var _cookie = Cookies.get(__name__);
      _cookie += "," + id;
      Cookies.set(__name__, _cookie, { expires : 60, path: "" });
    }
  }
};

// CookieにID値があるかどうかの確認
var CheckCookieValue = function(id){
  if(Cookies.get(__name__) === undefined){
    return undefined;
  }else{
    var _cookies = Cookies.get(__name__).split(",");
    for(var i = 0; i < _cookies.length; i++){
      if((_cookies[i]).toString() === _cookiePrefix + id){
        return true;
      }
    }
    return false;
  }
};

// シャッフル
var shuffle = function([...array]){
  for(var i = array.length - 1; i >= 0; i--){
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

// LISTの高さ調整
var SetListHeight = function(){
  if($window.outerHeight() <= $body.outerHeight()){
    $list.css({"min-height": ""});
  }else{
    var adjustHeight = $window.height() - ($top.height() + $footer.height());
    $list.css({"min-height": adjustHeight});
  }
};

// 全記事GET
var GetAllPosts = function(){
  __c__('GetAllPosts');
  var _checkTimer = setInterval(function(){
    __c__("checkTimer");
    if(_vars.key !== ""){
      var jqxhr = $.ajax({
        url: _vars.path + 'posts',
        type:'GET',
        headers: {
          "api-key" : _vars.key
        },
        timeout: 30000,
      }).done(function(data) {
        __c__('success GetAllPosts');
        if(data.length !== 0){
          var __data = data;
          // __data = shuffle(data); // Random
          __data = data.sort((a, b) => b.id - a.id); // 降順

          originalData = originalData.concat(__data);

          allData = originalData.concat();
          __c__(allData);

          if(readPage === 1){
            $(window).trigger("JSONLoaded");
            __c__("JSONLoaded");
          }else{
            $(window).trigger("MoreJSONLoaded");
            __c__("MoreJSONLoaded");
          }
          readPage++;

          //__c__(__data);
        }else{
          $(".list-more--btn").css({display: "none"});
          $("#action").append('<p class="action--nothing">投稿されたアクションはありません。</p>');
          SetListHeight();
        }
      }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        if(textStatus === "timeout"){
          alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
        }else{
          console.dir(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
          if(textStatus !== 'abort'){
            alert('データ受信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + errorThrown.message + ' >>');
          }

        }
        jqxhr.abort();
      });

      clearInterval(_checkTimer);
    }
  }, 250);
};

var isCommentOnce = false;
// コメント送る
var PostComment = function(id){
  if(isEndVote) return;

  if(!isCommentOnce){
    history.pushState(null, null, null);
    isCommentOnce = true;
  }else{
    history.replaceState(null, null, null);
  }

  var $commentBtn = $("#comment_form_btn").addClass("disabled").prop('disabled', true);
  var form_obj = document.getElementById('comment_form');
  var formData = new FormData(form_obj);

  var _back = function(){
    __c__("browser back");
    if(jqxhr){
      jqxhr.abort();
      __c__("jqxhr.abort");
    }
  }

  window.addEventListener('popstate', _back);

  var jqxhr = $.ajax({
    url: _vars.path + "comment/" + id,
    type:'POST',
    headers: {
      "api-key" : _vars.key
    },
    data: formData,
    dataType: 'json',
    processData: false,
    contentType: false,
    timeout: 10000,
  }).done(function(data) {
    __c__('success PostComment');

    AddIsComment(id);

    var _name = $("#comment_name").val();
    var _contents = $("#comment_contents").val();
    var _date = new Date();

    var _year = _date.getFullYear();
    var _month = ("0" + (_date.getMonth() + 1)).slice(-2);
    var _day = ("0" + _date.getDate()).slice(-2);

    var _$commentBox = $("<div class='comment-box' style='opacity: 0;'></div>");
    var _$commentName = $("<p class='comment--name'>" + _name + "</p>");
    var _$commentDate = $("<p class='comment--date'>" + _year + "/" + _month + "/" + _day + "</p>");
    var _$commentContents = $("<p class='comment--contents'>" + _contents + "</p>");

    _$commentBox.append(_$commentName);
    _$commentBox.append(_$commentDate);
    _$commentBox.append(_$commentContents);
    $("#comment").prepend(_$commentBox);

    $("#comment_name").val("");
    $("#comment_contents").val("");

    _$commentBox.animate({opacity: 1}, 700).queue(function(){
      _$commentBox.css({opacity: ""}).dequeue();
      $commentBtn.removeClass("disabled").prop('disabled', false);
      window.removeEventListener('popstate', _back);
    });

  }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
    if(textStatus === "timeout"){
      alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
    }else{
      console.dir(XMLHttpRequest);
      console.log(textStatus);
      console.log(errorThrown);
      if(textStatus !== 'abort'){
        alert('送信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + errorThrown.message + ' >>');
      }
    }
    jqxhr.abort();
  });
};

// コメントゲットする
var GetComment = function(id){
  var jqxhr = $.ajax({
    url: _vars.path + "comments/" + id,
    type:'GET',
    headers: {
      "api-key" : _vars.key
    },
    //data: { "id": id },
    dataType: 'json',
    processData: false,
    contentType: false,
    timeout: 10000,
  }).done(function(data) {
    __c__('success GetComment');
    if(data.length > 0){
      var _data = data.sort((a, b) => b.id - a.id);
      SetComments(_data);
    }else{
      return false;
    }
  }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
    if(textStatus === "timeout"){
      alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
    }else{
      console.dir(XMLHttpRequest);
      console.log(textStatus);
      console.log(errorThrown);
      if(textStatus !== 'abort'){
        alert('データ受信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + errorThrown.message + ' >>');
      }
    }
    jqxhr.abort();
    return false;
  });
};

// Comment表示
var SetComments = function(data){
  __c__('SetComments');
  var _$commentContainer = $("#comment");
  for(var i = 0; i < data.length; i++){
    var _data = data[i];
    var _name = _data["name"];
    var _contents = _data["contents"];
    var _date = new Date(_data["created_at"].replace(/-/g, "/"));
    var _year = _date.getFullYear();
    var _month = ("0" + (_date.getMonth() + 1)).slice(-2);
    var _day = ("0" + _date.getDate()).slice(-2);

    var _$commentBox = $("<div class='comment-box'></div>");
    var _$commentName = $("<p class='comment--name'>" + _name + "</p>");
    var _$commentDate = $("<p class='comment--date'>" + _year + "/" + _month + "/" + _day + "</p>");
    var _$commentContents = $("<p class='comment--contents'>" + _contents + "</p>");

    _$commentBox.append(_$commentName);
    _$commentBox.append(_$commentDate);
    _$commentBox.append(_$commentContents);
    _$commentContainer.append(_$commentBox);
  }
};

// Good送信
var PostGood = function(id, action, callback){
  if(isEndVote) return;

  // Step2のアクションにあるGoodにも反映する
  var AddGood = function(_id_){
    // 一覧部分の数字
    var _$action = $("#action .action-wrapper[data-action-id=" + _id_ + "]");
    var _$goodBtn = _$action.find(".action-good--btn");
    var _$goodNumberNode = _$action.find(".action-good--number");
    var _currentGood = _$goodNumberNode.text() | 0;
    var _addNumber = (_currentGood + 1).toString();
    _$goodNumberNode.text(_addNumber);
    if(!_$goodBtn.hasClass("disabled")){
      _$goodBtn.addClass("disabled")
    }

    // modal内の数字
    var _$modalAction = $("#modal .action-box[data-action-id=" + _id_ + "]");
    var _$modalActionWrap = _$modalAction.find('.action-good');
    var _$modalActionNumber = _$modalAction.find('.action-good-container span');
    _$modalActionNumber.text(_addNumber);
  };

  var _callback = null;
  if(action === void 0 && typeof callback === "function"){
    _callback = callback;
  }

  var jqxhr = $.ajax({
    url: _vars.path + "post/like/" + id,
    type:'POST',
    headers: {
      "api-key" : _vars.key
    },
    //data: { "id": id },
    dataType: 'json',
    processData: false,
    contentType: false,
    timeout: 10000,
  }).done(function(data) {
    __c__('success PostGood');

    AddGood(id);
    AddGoodToArticle(id);
    SetCookieValue(_cookiePrefix + id);

    if(action !== void 0){
      action.id += 1;
    }

    if(_callback !== null && typeof _callback === "function"){
      _callback();
    }

  }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
    if(textStatus === "timeout"){
      alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
    }else{
      console.dir(XMLHttpRequest);
      console.log(textStatus);
      console.log(errorThrown);
      if(textStatus !== 'abort'){
        alert('送信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + errorThrown.message + ' >>');
      }
    }
    jqxhr.abort();
  });
};

// IDから
var ArticleFormAlldata = function(id){
  __c__('ArticleFormAlldata');
  var _length = allData.length;
  for(var i = 0; i < _length; i++){
    var _action = allData[i];
    if(_action.id === id){
      return _action;
    }
  }
  return null;
};

// 既存のデータにGood足す
var AddGoodToArticle = function(id){
  __c__('AddGoodToArticle');
  var _length = allData.length;
  for(var i = 0; i < _length; i++){
    if(allData[i].id === id){
      allData[i].like += 1;
      return;
    }
  }
};

// コメントがあれば一覧にClassを追加
var AddIsComment = function(id){
  // 一覧部分の数字
  var _$action = $("#action .action-wrapper[data-action-id=" + id + "]");
  var _$commentPop = _$action.find(".action-comment--btn");
  if(!_$commentPop.hasClass("is-comment")){
    _$commentPop.addClass("is-comment")
  }
};

// コメントがあるかどうかの確認
var CheckIsComment = function(id, cb){
  var jqxhr = $.ajax({
    url: _vars.path + "comments/" + id,
    type:'GET',
    headers: {
      "api-key" : _vars.key
    },
    //data: { "id": id },
    dataType: 'json',
    processData: false,
    contentType: false,
    timeout: 10000,
  }).done(function(data) {
    __c__('success CheckIsComment');
    if(data.length > 0){
      AddIsComment(id);
    }

    if(cb) cb();
  }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
    if(textStatus === "timeout"){
      alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
    }else{
      console.dir(XMLHttpRequest);
      console.log(textStatus);
      console.log(errorThrown);
      if(textStatus !== 'abort'){
        alert('データ受信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + errorThrown.message + ' >>');
      }
    }
    jqxhr.abort();
    if(cb) cb();
    return false;
  });
};

// メイン画面
var Init = function(){
  GetAllPosts();

  var _isFirstModal = false;

  // 直リンアンカー
  var GoLocationHash = function(){
    var _$target = $(_hash);
    if(_$target.length > 0){
      $("html, body").stop().animate({scrollTop: _$target.position().top}, 300, function(){
        //window.location.hash = '';
      });
    }

    if(_hash && !_isFirstModal){
      //data-action-id="8"
      var _actionOpneId = _hash.replace("#" + _cookiePrefix, "") | 0;
      __c__("_actionOpneId: " + _actionOpneId);
      var $targetContent = $('<div class="action-box modal--btn" data-modal-id="modal" data-modal-content="action" data-action-id="' + _actionOpneId + '"></div>');
      $body.append($targetContent);
      if(OutputModalAction(ArticleFormAlldata(_actionOpneId))){
        $targetContent.trigger("click");
        _isFirstModal = true;
      }
    }else{
    }

  };
  var $moreButton = $("#more_btn");
  var $modal = $("#modal");
  var $actionContainer = $("#action");
  var $actionModalContainer = $("#action_modal .action-box");
  var $actionModalForm = $("#action_form .action-box");
  var s3 = "https://images-tokyuland-scm-prod.s3.ap-northeast-1.amazonaws.com/";

  if(isDebug){
    s3 = 'https://images-tokyufudosan-dev.s3.ap-northeast-1.amazonaws.com/';
  }

  var filterObj = [];
  var moreCount = $moreButton.data("more-count") | 0;
  moreCount = moreCount ? moreCount : 10;

  // 初回読み込み分
  var InitialSetActions = function(){
    __c__("InitialSetActions");
    var _initNum = moreCount;
    currentCount = 0;
    outputCount = 0;
    for(var i = 0; i < _initNum; i++){
      var _action = allData[i];
      if(_action){
        OutputAction(_action);
      }
    }

    //currentCount = _initNum;

    var _length = allData.length;
    if(_initNum >= _length){
      $(".list-more--btn").css({display: "none"});
    }else{
      $(".list-more--btn").css({display: ""});
    }

    if(_length === 0){
      $(".list-more--btn").css({display: "none"});
      $("#action").append('<p class="action--nothing">投稿されたアクションはありません。</p>');
    }

    GoLocationHash();
    SetListHeight();
  };

  // メイン画面の初期
  var Initial = function(){
    isFilter = true;

    if(isFilter){
      // Filteringされたものを出力
      // Sort Checkbox見に行ってから出力させる
      ActionFilter();
    }else{
      // NO Filtering で出力
      InitialSetActions();
    }

    $window.off("JSONLoaded", Initial);
    //$window.on("scroll", ScrollMore);

    GetKollusInfo();
  };

  // Scroll de MORE
  var nowMore = false;
  var ScrollMore = function(){
    if($window.scrollTop() >= $body.height() - $window.height() - $footer.height()){
      if(nowMore){
      }else{
        nowMore = true;
        SetMoreActions();
        __c__("ScrollMore");
      }
    }
  };

  // kollus動画情報をゲットする
  var GetKollusInfo = function(uploadKey, cb){
    __c__(">>>>>>> GetKollusInfo <<<<<<<")
    var kollusData = null;

    uploadKey = uploadKey ? uploadKey : "20240515-dfr2bowa";

    var kollusJqxhr = $.ajax({
      url: 'https://api.jp.kollus.com/0/media/library/media_content/' + uploadKey + "?access_token=bf9bdmri12bm5gf0",
      type:'GET',
      dataType: 'json',
      data: {
        "accept": 'application/json',
      },
      processData: false,
      contentType: false,
    }).done(function(data) {

      if(cb) cb(data.result.item);

    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
      if(textStatus === "timeout"){
        alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
      }else{
        //console.dir(formData.getAll('images[]'));
        console.dir(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
        var _message = '';
        var _keys = Object.keys(XMLHttpRequest.responseJSON.message);
        if(_keys.length > 0){
          for(let key in XMLHttpRequest.responseJSON.message){
            _message += XMLHttpRequest.responseJSON.message[key] + ',';
          }
        }
        if(textStatus !== 'abort'){
          alert('送信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + _message + ' >>');
        }
      }
      kollusJqxhr.abort();
      //window.location.reload();
    });

    /*const options = {method: 'POST', headers: {
        accept: 'application/json'
      }};

    fetch('https://api.jp.kollus.com/0/media/library/media_content/' + uploadKey + '?access_token=bf9bdmri12bm5gf0', options)
      .then(response =>
        kollusData = response.json()
      )
      .then(response => console.log(response))
      .catch(err => console.error(err));*/

    return kollusData;
  };

  // Step2に1記事出力
  var OutputAction = function(data){
    __c__("OutputAction");
    __c__("ID:" + data.id);
    var _id = data.id;
    var _title = data.title;
    var _theme = data.theme ? data.theme : "theme";
    var _storeName = data.store_name;
    var _storeCategory = data.store_category;
    var _facility = data.facility;
    var _text = "";
    var _good = data.like;
    var _comment = data.comment;
    var _mediaKey = data["media_content_key"];
    var _uploadKey = data["upload_file_key"];

    __c__("theme: " + _theme);

    var _$wrapper = $('<div class="action-wrapper" data-action-id="' + _id + '" data-action-category="' + _storeCategory + '" data-action-facility="' + _facility + '" data-action-theme="' + _theme + '">');
    _$wrapper.css({opacity: 0});
    $actionContainer.append(_$wrapper);

    //CheckIsComment(_id, function(){_$wrapper.animate({opacity: 1}, 300);});

    var isNotMore = false;
    //var segmenter = new Intl.Segmenter("ja", { granularity: "grapheme" });
    //var _contents = [...segmenter.segment(data.contents)];
    /*for(var a = 0; a < 10; a++){
      if(_contents[a]){
        _text += _contents[a].segment;
      }else{
        isNotMore = true;
      }
    }*/

    GetKollusInfo(_uploadKey, function(kollusData){
      var _$box = $('<div class="action-box modal--btn" data-modal-id="modal" data-modal-content="action" data-action-id="' + _id + '">');
      var _$ttl = $('<p class="action--ttl">').text(_title);
      var _$txt = $('<p class="action--txt">').text(_text);
      var _$store = $('<p class="action--store_name">').text(_storeName);
      var _$thumb = $('<div class="action--thumb"><img src="' + kollusData["poster_url"] + '"></div>');
      var _$good = $('<div class="action-good-content"><div class="action-good--btn" data-good-id="' + _id + '"></div><span class="action-good--number">' + _good + '</span><div class="action-comment--btn modal--btn" data-modal-id="modal" data-modal-content="action" data-action-id="' + _id + '"></div></div>');
      var _$seeComment = $('<p class="action--comment">').text("コメントを見る");

      if(!isNotMore) {
        _$txt.append($('<span></span>').text("...more"));
      }

      if(CheckCookieValue(_id) === true){
        _$good.find(".action-good--btn").addClass("disabled");
      }

      var thisFacility = facilities[_facility];

      _$box.append(_$thumb);
      if(thisFacility !== void 0){
        var _$facility;
        if(thisFacility.indexOf("tp_") > -1){
          _$facility = $('<div class="action--logo tp"><img src="assets/img/logo_' +  thisFacility + '.png" alt="' + _facility + '"></div>');
        }else if(
          _facility.indexOf("キューズモール") > -1 ||
          _facility.indexOf("ノースポート") > -1
        ){
          _$facility = $('<div class="action--logo qsn"><img src="assets/img/logo_' +  thisFacility + '.png" alt="' + _facility + '"></div>');
        }else if(_facility.indexOf("COCONO") > -1){
          _$facility = $('<div class="action--logo cocono"><img src="assets/img/logo_' +  thisFacility + '.png" alt="' + _facility + '"></div>');
        }else{
          _$facility = $('<div class="action--logo"><img src="assets/img/logo_' +  thisFacility + '.png" alt="' + _facility + '"></div>');
        }
        _$box.append(_$facility);
      }
      _$box.append(_$ttl);
      _$box.append(_$store);
      _$box.append(_$seeComment);

      if(isEndVote){}

      _$wrapper.append(_$box);
      _$wrapper.append(_$good);

      // comment あるかどうかの処理
      var _$commentPop = _$wrapper.find(".action-comment--btn");
      if(_comment > 0){
        _$commentPop.addClass("is-comment")
      }
      _$wrapper.animate({opacity: 1}, 300);
    });

    outputCount++;
    currentCount++;
    __c__("outputCount:" + outputCount);
  }

  // Modalに1記事出力
  var OutputModalAction = function(data){
    __c__("OutputModalAction");
    if(data === null || data === void 0) return false;

    $actionModalContainer.empty().attr("data-action-id", "").attr("data-action-category", "");

    var _id = data.id;
    var _theme = data.theme;
    var _attempt = data.attempt;
    var _title = data.title;
    var _contents = data.contents;
    var _facility = data.facility;
    var _storeName = data.store_name;
    var _storeCategory = data.store_category;
    var _nickname = data.nickname;
    var _good = data.like.toString();
    var _mediaKey = data["media_content_key"];
    var _uploadKey = data["upload_file_key"];

    __c__("data.id is ===>" + _id);

    $actionModalContainer.attr("data-action-id", _id);
    $actionModalContainer.attr("data-action-category", _storeCategory);

    var _$ttl = $('<p class="action--ttl"><span>' + _title + '</span></p>');
    var _$contents = $('<pre class="action--contents">').text(_contents);
    var _$store = $('<p class="action--store"><span>' + _storeName + '</span></p>');
    var _$nickname = $('<p class="action--nickname"><span>' + _nickname + '</span></p>');

    var _$videoContainer = $('<div class="action-video"></div>');
    _$videoContainer.css({paddingTop: ""});


    GetKollusInfo(_uploadKey, function(data){
      __c__(data);
      var videoSize = data["transcoding_files"][0]["media_information"]["video"]["video_screen_size"].split("x").map(function(a){ return a;});
      var w = videoSize[0];
      var h = videoSize[1];

      var aspectH = ((h / w) * 100).toString() + "%";

      _$videoContainer.css({paddingTop: aspectH});

    });

    var _$player = $('<iframe width="auto" height="auto" src="https://v.jp.kollus.com/' + _mediaKey + '?player_version=html5&title=%20" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>');

    _$videoContainer.append(_$player);
    $actionModalContainer.append(_$videoContainer);

    var _$goodContainer = $('<div class="action-good-container"></div>');
    var _$goodButton = $('<div id="good_btn" class="action-good--btn" data-good-id="' + _id + '"></div>');


    if(CheckCookieValue(_id) === true){
      _$goodButton.addClass("disabled");
    }

    if(facilities[_facility].indexOf("omokado") > -1 || facilities[_facility].indexOf("harakado") > -1){
      _$store.addClass("vertical");
    }

    var _$facility;
    if(facilities[_facility] !== void 0){
      _$facility = $('<div class="action--logo"><img src="assets/img/logo_' +  facilities[_facility] + '.png" alt="' + _facility + '"></div>');
    }else{
      _$facility = $('<div class="action--logo"></div>');
    }

    $actionModalContainer.append(_$facility);

    _$goodContainer.append(_$goodButton);
    _$goodContainer.append($('<span>' + _good + '</span>'));
    $actionModalContainer.append(_$goodContainer);

    var _commentOutputWrapper = $("<div class='comment-content' id='comment'></div>");
    $actionModalForm.append(_commentOutputWrapper);

    var _commentForm = $("<form class='comment-form' id='comment_form'></form>");
    var _commentFormInner = $("<div class='comment-form-inner'></div>");
    var _commentName = $("<label class='comment-form--name' for='comment_name'><input name='name' maxlength='250' required placeholder='名前' id='comment_name'></label>");
    var _commentContent = $("<label class='comment-form--contents' for='comment_contents'><textarea name='contents' maxlength='5000' required placeholder='コメント' rows='1' id='comment_contents'></textarea></label>");

    var _commentButton = $("<button type='submit' class='comment-form--btn' id='comment_form_btn' data-action-id='" + _id + "'></button>");

    _commentFormInner.append(_commentName);
    _commentFormInner.append(_commentContent);
    _commentFormInner.append(_commentButton);
    _commentForm.append(_commentFormInner);
    $actionModalForm.append(_commentForm);


    if(isEndVote){
      // 投票終了時の対応
    }

    $actionModalContainer.append(_$ttl);
    $actionModalContainer.append(_$store);

    GetComment(_id);

    return true;
  }

  // クリック OR タップでモーダル記事
  var SelectAction = function(event){
    __c__("SelectAction");
    var _$target = $(event.currentTarget);
    var _id = _$target.data("action-id");
    OutputModalAction(ArticleFormAlldata(_id));
  };

  // GOODボタンを押す
  var GoodButtonClicked = function(event){
    if(isEndVote) return;
    __c__("GoodButtonClicked");
    var _$btn = $(event.currentTarget);
    var _id = _$btn.data("good-id");

    if(CheckCookieValue(_id) !== true){
      PostGood(_id);
    }

    _$btn.addClass("good-action").delay(500).queue(function(){
      _$btn.addClass("disabled").removeClass("good-action").dequeue();
    });
  };

  // MORE
  var SetMoreActions = function(){
    __c__("===== SetMoreActions =====");
    var _now = currentCount;
    var _data;

    if(isFilter){
      _data = filteredData;
    }else{
      _data = allData;
    }

    var _length = _data.length;
    var moreData = moreCount;


    if(currentCount >= _length){
      $moreButton.css({display: "none"});
      return
    }

    // Xずつ
    var _maxNum = _now + moreData;

    // 全部出力
    //var _maxNum = allData.length;

    for(var i = _now; i < _maxNum; i++){
      var _action = _data[i];
      if(_action){
        OutputAction(_action);
      }
    }

    __c__("currentCount:" + currentCount);

    nowMore = false;

    if(currentCount >= _length){
      $moreButton.css({display: "none"});
    }else{
      $moreButton.css({display: ""});
    }

    __c__("===== END SetMoreActions =====");
  };

  // filtering
  // 再度データをひっぱるのではなく、持ってるデータをFilteringするようにする
  // filteringするものがなければ全データに戻す
  var GetFilteredPosts = function(){
    __c__("ーーーーーGetFilteredPostsーーーーー");
    __c__(filterObj);
    __c__("isFilter: " + isFilter);

    if(filterObj.themes.length === 0 && filterObj.facilities.length === 0 && filterObj.categories.length === 0){
      if(isFilter){
        isFilter = false;

        currentCount = 0;
        outputCount = 0;
        $actionContainer.empty();
        InitialSetActions();
      }
    }else{
      isFilter = true;

      var filteringData = allData.map(function(d){
        var _theme = d.theme;
        var _facility = d.facility;
        var _category = d.store_category;
        var _isTheme = false;
        var _isFacility = false;
        var _isCategory = false;
        if(filterObj.themes.length !== 0){
          for(var t = 0; t < filterObj.themes.length; t++){
            if(_theme === filterObj.themes[t] || _theme === themesReverse[filterObj.themes[t]]){
              _isTheme = true;
              break;
            }
          }
        }else{
          _isTheme = true
        }

        if(filterObj.facilities.length !== 0){
          for(var f = 0; f < filterObj.facilities.length; f++){
            if(_facility === filterObj.facilities[f]){
              _isFacility = true;
              break;
            }
          }
        }else{
          _isFacility = true
        }

        if(filterObj.categories.length !== 0){
          for(var c = 0; c < filterObj.categories.length; c++){
            if(_category === filterObj.categories[c]){
              _isCategory = true;
              break;
            }
          }
        }else{
          _isCategory = true;
        }

        if(_isTheme && _isFacility && _isCategory){
          return d;
        }
      });


      filteredData = [];
      for(var f = 0; f < filteringData.length; f++){
        if(filteringData[f] !== void 0){
          filteredData.push(filteringData[f]);
        }
      }

      __c__("filteredData");
      __c__(filteredData);

      currentCount = 0;
      outputCount = 0;
      $actionContainer.empty();

      var _length = filteredData.length;
      var _max = outputCount + moreCount;

      for(var i = currentCount; i < _length; i++){
        if(outputCount < _max){
          var _action = filteredData[i];
          if(_action){
            OutputAction(_action);
          }
        }else{
          break;
        }
      }

      var _checkTimer = setTimeout(function(){
        if($actionContainer.find(".action-box").length === 0){
          $actionContainer.append('<p class="action--nothing">ご指定のアクションはまだありません。</p>');
        }
        clearTimeout(_checkTimer);
      }, 2000);


      if(currentCount >= _length){
        $(".list-more--btn").css({display: "none"});
      }else{
        $(".list-more--btn").css({display: ""});
      }

      nowMore = false;
    }

    __c__("ーーーーーEND GetFilteredPostsーーーーー");
  };

  // Filtering情報を整理してGetFilteredPostsにわたす
  var ActionFilter = function(event){
    __c__("ActionFilter");
    $modal.find(".sort-start").removeClass("sort-start")

    var _themes = [];
    var _facilities = [];
    var _categories = [];

    $("input[name='theme']:checked").each(function(){
      _themes.push(this.value);
    });
    $("input[name='facility']:checked").each(function(){
      _facilities.push(this.value);
    });
    $("input[name='category']:checked").each(function(){
      _categories.push(this.value);
    });

    filterObj.themes = function(){
      var isAll = false;
      for(var i = 0; i < _themes.length; i++){
        if(_themes[i] === "ALL"){
          __c__("filtering themes: ALL");
          isAll = true;
          return [];
        }
      }
      if(!isAll){
        __c__("filtering themes: " + _themes);
        return _themes;
      }
    }();
    filterObj.facilities = function(){
      var isAll = false;
      for(var i = 0; i < _facilities.length; i++){
        if(_facilities[i] === "ALL"){
          __c__("filtering facilities: ALL");
          isAll = true;
          return [];
        }
      }
      if(!isAll){
        __c__("filtering facilities: " + _facilities);
        return _facilities;
      }
    }();
    filterObj.categories = function(){
      var isAll = false;
      for(var i = 0; i < _categories.length; i++){
        if(_categories[i] === "ALL"){
          __c__("filtering categories: ALL");
          isAll = true;
          return [];
        }
      }
      if(!isAll){
        __c__("filtering categories: " + _categories);
        return _categories;
      }
    }();

    GetFilteredPosts();
  };

  // Filtering チェックボックス用
  var $filterCheckboxes = $(".sort input[type=checkbox]");
  var CheckboxesFunc = function(event){
    __c__("CheckboxesFunc");
    var _$current = $(event.currentTarget);
    var _thisValue = _$current.val();
    var _thisName = _$current.attr("name");
    var _$same = $("input[name=" + _thisName + "]");

    var _isAll = _thisValue === "ALL";

    _$same.each(function(i){
      if(_isAll){
        _$same[i].checked = i === 0;
      }else{
        if(i === 0){
          _$same[i].checked = false;
        }
      }
    });
  };

  // 規約見たらボタンアクティブにする
  var $termBtn = $(".term-check");
  var $step1Btn = $(".step1--btn.modal--btn");
  var CheckedTerm = function(event){
    var _num = event.data.num;
    var _isCheck = event.currentTarget.checked;
    if(_isCheck){
      $($step1Btn[_num]).removeClass("disabled");
    }else{
      $($step1Btn[_num]).addClass("disabled");
    }
  };

  // コメント送信用
  var SubmitCommentData = function(event){
    var falseCount = 0;

    $("#comment_form input[required], #comment_form textarea[required]").each(function(){
      if(!this.reportValidity()){
        falseCount++;
      }
    });

    if(falseCount === 0){
      var _id = $(event.currentTarget).data("action-id");
      __c__("action-id is -->" + _id);
      PostComment(_id);
    }else{
      console.log("validation is false. Cant Post Comment.")
    }

    return false;
  };

  // モーダル閉じるときに発動
  var ModalClose = function(){
    $("#action_modal .action-box").empty().removeAttr("data-action-id").removeAttr("data-action-category");
    $("#comment").empty();
    $("#action_form .action-box").empty();
  }

  // reload
  var Reload = function(){
    __c__('RELOAD');
    window.location.hash = 'list';
    window.location.reload();
  }

  // schedule modal accordion
  var $scheduleBox = $(".schedule-box");
  $scheduleBox.each(function(){
    var _$box = $(this);
    var _$head = _$box.find(".schedule--head");
    var _$content = _$box.find(".schedule-box-content");
    if(_$content.length > 0) {

      var accordion = function(){
        if(_$box.hasClass("open")){
          _$box.removeClass("open")
          _$content.slideUp();
        }else{
          _$box.addClass("open")
          _$content.slideDown();
        }
      }

      _$head.on("click", accordion);
    }
  });

  $window.on("JSONLoaded", Initial);
  $actionContainer.on("click", ".action-box, .action-comment--btn", SelectAction);
  $body.on("click", "#modal_sort_btn", ActionFilter);
  $body.on("click", ".reload", Reload);
  $(".list-more--btn").on("click", SetMoreActions);
  $filterCheckboxes.on("change", CheckboxesFunc);
  $termBtn.each(function(i){
    $(this).on("click", {num: i}, CheckedTerm);
  });
  $modal.on("click", ".modal--close", ModalClose);
  if(!isEndVote){
    $modal.on("click", ".comment-form--btn", SubmitCommentData);
    $body.on("click", ".action-good--btn", GoodButtonClicked);
  }else{
    //$(".note--btn").trigger("click");
  }

};

window.addEventListener("load", Init);
